import { IItemOrcamento } from "app/types/IItemOrcamento";
import clsx from "clsx";
import { useFormik } from "formik";
import globalMU from "globalMU";
import React, { useState } from "react";


const estiloProdutoSemEstoque = require("./produtoSemEstoqueDisponivel.module.scss").default;
const estilosBotoes = require('../../../estilos/botoes.module.scss').default
const estilosFormulario = require('../../../estilos/formulario.module.scss').default

export type EstoqueProdutoSemEstoqueDisponivel = {
    CodigoFilial: string
    Quantidade: number
    QuantidadeReservada: number,
    QuantidadePedida: number
    QuantidadeDisponivel: number,
    QuantidadeDiferenca?: number,
    QuantidadePedidoFornecedor: number

}

export type DadosSemEstoqueDisponivel = {
    Codigo: string
    CodigoProduto: string
    Descricao: string
    Estoques: EstoqueProdutoSemEstoqueDisponivel[],
    UserMessage?: string,
    Transforming: boolean
}

export type DadosProdutoSemEstoqueDisponivel = {
    AjustarQuantidadePedida: boolean,
    LancarDiferencaEmCotacaoPerdida: boolean
    LancarQuantidadePedidaEmCotacaoPerdida: boolean
}

export type ProdutoSemEstoqueDisponivelProps = {
    item: IItemOrcamento
    dadosSemEstoqueDisponivel: DadosSemEstoqueDisponivel
    codigoFilial: string
    onExcluirItens: (item: IItemOrcamento) => void
    onAlterarQuantidadeItem: () => void
    onConfirmar: (dadosProdutoSemEstoqueDisponivel: DadosProdutoSemEstoqueDisponivel) => void
};


export const ProdutoSemEstoqueDisponivel = (props: ProdutoSemEstoqueDisponivelProps) => {


    const formik = useFormik<DadosProdutoSemEstoqueDisponivel>({
        initialValues: { 
            AjustarQuantidadePedida: props.item.QuantidadeEstoque > 0,
            LancarDiferencaEmCotacaoPerdida: props.item.QuantidadeEstoque > 0,
            LancarQuantidadePedidaEmCotacaoPerdida: props.item.QuantidadeEstoque <= 0
         },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
    });


    return (
        <>
            <div className={estiloProdutoSemEstoque.infoProdutos}>
                <label>Produto</label>
                <div>{props.dadosSemEstoqueDisponivel?.CodigoProduto}</div>
                <label>Descrição</label>
                <div>{props.dadosSemEstoqueDisponivel?.Descricao}</div>
            </div>

            <br />

            <div>
                <div className={`_table _w-full _border-collapse ${estiloProdutoSemEstoque.tabelaProdutoSemEstoqueDisponivel}`}>
                    <div className="_table-header-group">
                        <div className="_table-row">
                            <div
                                className={`_table-cell ${estiloProdutoSemEstoque.tableCellHeader}`}
                            >
                                Filial
                            </div>
                            <div
                                className={`_table-cell ${estiloProdutoSemEstoque.tableCellHeader}`}
                            >
                                Quantidade
                            </div>
                            <div
                                className={`_table-cell ${estiloProdutoSemEstoque.tableCellHeader}`}
                            >
                                Reservado
                            </div>
                            <div
                                className={`_table-cell ${estiloProdutoSemEstoque.tableCellHeader}`}
                                style={{ textAlign: "right" }}
                            >
                                Dispoonível
                            </div>
                            <div
                                className={`_table-cell ${estiloProdutoSemEstoque.tableCellHeader}`}
                                style={{ textAlign: "right" }}
                            >
                                Pedida
                            </div>
                            <div
                                className={`_table-cell ${estiloProdutoSemEstoque.tableCellHeader}`}
                                style={{ textAlign: "right" }}
                            >
                                Diferença
                            </div>
                        </div>
                    </div>

                    <div className="_table-row-group">
                        {props.dadosSemEstoqueDisponivel?.Estoques?.sort((cf1, cf2) => cf1.CodigoFilial > cf2.CodigoFilial ? 1 : -1).map((value) => (
                            <div
                                key={value.CodigoFilial}
                                className={`_table-row `} style={props.codigoFilial == value.CodigoFilial ? { backgroundColor: "rgb(255, 255, 204)" } : {}}>
                                <div
                                    className={`_table-cell ${estiloProdutoSemEstoque.tableCellBody}`}
                                >
                                    {value.CodigoFilial}
                                </div>
                                <div
                                    className={`_table-cell ${estiloProdutoSemEstoque.tableCellBody}`}
                                >
                                    {globalMU.formatarValorNumerico(value.Quantidade, 3)}
                                </div>
                                <div
                                    className={`_table-cell ${estiloProdutoSemEstoque.tableCellBody}`}
                                >
                                    {globalMU.formatarValorNumerico(value.QuantidadeReservada, 3)}
                                </div>
                                <div
                                    className={`_table-cell ${estiloProdutoSemEstoque.tableCellBody}`}
                                    style={{ textAlign: "right" }}
                                >
                                    {globalMU.formatarValorNumerico(value.QuantidadeDisponivel, 3)}
                                </div>
                                <div
                                    className={`_table-cell ${estiloProdutoSemEstoque.tableCellBody}`}
                                    style={{ textAlign: "right" }}
                                >
                                    {globalMU.formatarValorNumerico(value.QuantidadePedida, 3)}
                                </div>
                                <div
                                    className={`_table-cell ${estiloProdutoSemEstoque.tableCellBody}`}
                                    style={{ textAlign: "right" }}
                                >
                                    {globalMU.formatarValorNumerico(value.QuantidadeDiferenca, 3)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>

            <br />


            <div className={estilosFormulario.formulario}>

                <>
                    <label>Ajustar a quantidade pedida para o valor disponível?</label>
                    <input 
                        className={estiloProdutoSemEstoque.checkbox} 
                        checked={formik.values.AjustarQuantidadePedida} 
                        type="checkbox" 
                        name="AjustarQuantidadePerdida"
                        onChange={(e) => { 
                            formik.setFieldValue("AjustarQuantidadePedida", e.target.checked)
                            formik.setFieldValue("LancarDiferencaEmCotacaoPerdida", e.target.checked)
                            formik.setFieldValue("LancarQuantidadePedidaEmCotacaoPerdida", !e.target.checked)
                            
                        }}
                        disabled={!(props.item.QuantidadeEstoque > 0)}
                        />
                </>

                <>
                    <label>Lançar a diferença em Cotação Perdida?</label>
                    <input 
                        className={estiloProdutoSemEstoque.checkbox} 
                        checked={formik.values.LancarDiferencaEmCotacaoPerdida} 
                        type="checkbox" 
                        name="LancarDiferencaCotacaoPerdida" 
                        disabled={!(formik.values.AjustarQuantidadePedida && props.item.QuantidadeEstoque > 0)}
                        onChange={e => formik.setFieldValue("LancarDiferencaEmCotacaoPerdida",e.target.checked)} />
                </>

                <>
                    <label>Lançar a quantidade pedida em Cotação Perdida?</label>
                    <input 
                        className={estiloProdutoSemEstoque.checkbox} 
                        disabled={!(!formik.values.AjustarQuantidadePedida || props.item.QuantidadeEstoque <= 0)}
                        checked={formik.values.LancarQuantidadePedidaEmCotacaoPerdida} 
                        type="checkbox" 
                        name="LancarQuantidadePedidaEmCotacaoPerdida"
                        onChange={(e) => { 
                            formik.setFieldValue("LancarQuantidadePedidaEmCotacaoPerdida", e.target.checked) 
                        }} />
                </>
            </div>

            <br />

            <div>
                <button
                    className={clsx(estilosBotoes.botaoPrimario, "_mt-3", "_mb-2")}
                    type="button"
                    onClick={() => props.onConfirmar(formik.values)}
                    
                >
                    OK
                </button>
            </div>
            {<section style={{ marginBottom: "100px" }} />}
        </>
    )
}